<template>
    <!--质疑管理-->
    <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
            <span>{{title}}</span>
        </div>
        <template>
            <el-form ref="form" class="form viewFormWrapper" label-width="180px">
                <el-row>
                    <el-col :span="24" style="margin-bottom: 30px">
                        <el-form-item style="width: auto" label-width="0px">
                            <el-input v-model.trim="keywords" style="width: 200px;margin-right: 10px" clearable placeholder="质疑人姓名" @keyup.enter.native="getCustomData"></el-input>
                            <el-button size="small" type="primary" @click="getCustomData">搜索</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="包件名称：" >
                            <span >{{projectInfo.purchaseProjectName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="包件编号：" >
                            <span >{{projectInfo.purchaseSectionCode}}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="归属采购项目名称：" >
                            <span >{{projectInfo.purchaseProjectName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="采购项目编码：" >
                            <span >{{projectInfo.purchaseProjectCode}}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div style="border:1px solid #ebeef5;padding: 24px;min-height: 100px;position: relative;margin: 20px 0px;">
                <div v-for="(item,index) in tableDataCopy" :key="item.id" class="dataWrapper"  v-loading="dataListLoading">
                    <div class="iconToolbar-left">
                        {{indexMethod(index)}}
                    </div>
                    <el-form label-width="150px" class="form viewFormWrapper" style="margin-bottom: 10px">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="质疑人：">
                                    <span >{{item.questionerName }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="质疑对象：">
                                    <span >{{item.object }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="质疑依据和理由：" >
                                    <span >{{item.reason }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="质疑内容：" >
                                    <el-input
                                            type="textarea"
                                            disabled
                                            :autosize="{ minRows: 2, maxRows: 6}"
                                            placeholder="请输入内容"
                                            v-model="item.content">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="affixDown" v-if="(item.attachments && item.attachments.length > 0)" style="margin-bottom: 10px">
                        <affix-doc v-for="(item,index) in item.attachments"
                                   labelWidth="150px"
                                   :item.sync="item"
                                   :index="index"
                                   :key="index"
                                   :name="item.titleName"></affix-doc>
                    </div>
                </div>
                <p style="text-align: center;margin-top: 50px" v-if="tableDataCopy.length == 0">暂无质疑数据</p>
                <el-pagination background
                               layout="sizes, prev, pager, next"
                               v-if="tableDataCopy.length > 0"
                               :page-sizes="[pageSize, 20, 50, 100]"
                               :page-size="pageSize"
                               :total="total"
                               :current-page="pageIndex"
                               @size-change="sizeChangeHandle"
                               @current-change="currentChangeHandle"></el-pagination>
            </div>


        </template>
    </el-card>

</template>

<script>
    import affixDoc from '@/components/affixDoc';
    import $ from "jquery";

    export default {
        components: {
            affixDoc
        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            title:{
                type:String,
                defalut:''
            },
            total:{
                type:Number,
                defalut:0
            },
            projectInfo:{
                type:Object,
                default:()=>({})
            },
            tableData:{
                type:Array,
                default:()=>([])
            },
            dataListLoading:{
                type:Boolean,
                defalut:false
            },

        },
        watch:{
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
            tableData: {
                immediate: true,
                handler (val) {
                    this.tableDataCopy = this.tableData.map((item, index) => {
                        let itemTemp = JSON.parse(JSON.stringify(item))
                        let attachmentTemp = [];
                        for(var key in itemTemp.fileTypeMap){
                            let obj = JSON.parse(JSON.stringify(itemTemp.fileTypeMap[key]))
                            obj.titleName = key;
                            attachmentTemp.push(obj);
                        }
                        if(itemTemp.attachments.length > 0){
                            itemTemp.attachments.forEach((itemTemp)=>{
                                let index = attachmentTemp.findIndex((val) => val.fileType == itemTemp.fileType);
                                if(index > 0){
                                    attachmentTemp[index] =  {...itemTemp};
                                }
                            })
                        }
                        itemTemp.attachments = attachmentTemp;
                        return itemTemp
                    })
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
        },
        data() {
            return {
                keywords:"",
                pageSize:10,//每页条数
                pageIndex:1,//当前页
                tableDataCopy:[],
                nodeCodeCopy:"",
            }
        },
        activated() {

        },
        methods: {
            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            fileDownload(filePath, fileName) {
                if (filePath) {
                    var a = document.createElement('a');
                    a.download = fileName;
                    a.target = "_Blank";
                    a.href = filePath;
                    $("body").append(a);
                    a.click();
                    $(a).remove();
                }
            },
            getCustomData(){
                this.pageIndex = 1;
                this.pageSize = 10;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
        }







    }
</script>

<style lang="less" scoped>

    .dataWrapper{
        position: relative;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 10px;
        &:last-child{
            border-bottom: none;
        }
        .iconToolbar-left{
            font-weight: bold;
            color: #fff;
            text-align: center;
            padding-top: 3px;
            position: absolute;
            top: 10px;
            left: 0px;
            width: 32px;
            height: 32px;
            background:url("../../assets/img/bookmark.png")no-repeat;
        }
    }
    .dataWrapper:last-child{
        border-bottom: none;
    }

</style>
